import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ViewClassComponent from '../ViewClassComponent/ViewClassComponent';
import './CategoryList.css';
import axiosInstance from '../../Config/axiosConfig';

function CategoryList() {
  const listRef = useRef(null);

  // Local state instead of Redux
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const fetchClasses = async () => {
    try {
      setLoading(true);
      setError(null);

      const endpoint = '/public/get-top-four-classes-with-most-subscriptions';
      const res = await axiosInstance.get(endpoint);

      // FIX: extract the real array
      const classesArray = res.data.data || res.data.classes || res.data || [];
      setData(Array.isArray(classesArray) ? classesArray : []);
      
    } catch (err) {
      setError(err.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  fetchClasses();
}, []);

  const WireframeLoader = () => (
    <div className="grid-container" aria-busy="true" aria-live="polite">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="wireframe-card">
          <div className="wireframe-image pulse-animation" />
          <div className="wireframe-line pulse-animation" style={{ width: '60%' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '80%', animationDelay: '0.2s' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '70%', animationDelay: '0.4s' }} />
        </div>
      ))}
    </div>
  );

  const renderedClasses = useMemo(() => (
    <div className="grid-container" ref={listRef}>
      {data.map((category) => (
        <ViewClassComponent 
          key={category.id} 
          classData={category}
        />
      ))}
    </div>
  ), [data]);

  return (
    <div className="category-grid-container">
      {loading ? (
        <WireframeLoader />
      ) : error && data.length === 0 ? (
        <p className="no-categories">Failed to load categories: {error}</p>
      ) : data.length > 0 ? (
        renderedClasses
      ) : (
        <p className="no-categories">No categories available</p>
      )}
    </div>
  );
}

CategoryList.propTypes = {};

export default CategoryList;
